import { render } from "./TrainingContactBlock.vue?vue&type=template&id=43f4a519"
import script from "./TrainingContactBlock.vue?vue&type=script&lang=js"
export * from "./TrainingContactBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__